import { Image, Spinner, VStack } from '@chakra-ui/react';
import { ForaLogo } from '@assets/images';

export default function FullPageLoader({ children }) {
  return (
    <VStack
      h='100vh'
      justify='center'
      gap={4}
      pb={32}
    >
      <Image
        src={ForaLogo}
        alt='logo'
        maxBlockSize={6}
      />
      <Spinner
        size='lg'
        thickness='3px'
        speed='0.75s'
        mt={4}
        mb={6}
      />
      {children}
    </VStack>
  );
}
